import * as React from 'react';

import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { Seat } from '../../classes/seat';
import { SeatingOption } from '../../classes/seating-option';
import { ISeatMapModel } from '../reducers/seatmap-reducer';
import SeatInfoOptions from './seat-info-options';

export interface ISeatInfoOptionsContainerProps {
    seat: Seat;
    appSettingsModel: IAppSettingsModel;
    onSelectSeatingOption: (seatingOptions: SeatingOption[], groupId: string) => void;
    selectedSeatingOptions: Array<SeatingOption>;
    seatmapModel: ISeatMapModel;
    isGAZone?: boolean;
}

class SeatInfoOptionsContainer extends React.Component<ISeatInfoOptionsContainerProps, any>{
    static defaultProps = {
        isGAZone: false
    }

    render() {
        return (<SeatInfoOptions {...this.props}
            seatingOptionGroup={this.props.seat.seatingOptionGroup}
            requestingSeatView={this.props.seatmapModel.requestingSeatView}
        />);
    }
}

export default SeatInfoOptionsContainer;